// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"162":"8f85d9a5","181":"0fb6a234","222":"bdb933af","249":"b36bccc5","268":"2ee790ba","436":"832908f0","480":"2e8b27e1","502":"264517ce","722":"45c3bb21","840":"8ae5cb2b","984":"421eee7e","989":"c1b9462a"}[chunkId] + ".chunk.js";
};